import React, { Component } from 'react';
import PropTypes from 'prop-types';
//import { Map, List } from 'immutable';

import * as currentStatusActions from 'modules/currentStatus';
import * as loginActions from 'modules/login';
import * as pwResetActions from 'modules/pwReset';
import * as registerActions from 'modules/register';
import * as userActions from 'modules/user';
import * as adminActions from 'modules/admin';
import * as templateActions from 'modules/template';
import * as licenseActions from 'modules/license';
import * as configActions from 'modules/config';
import * as examActions from 'modules/exam';
import * as examSummaryActions from 'modules/examSummary';
import * as examListActions from 'modules/examList';
import * as leakFileActions from 'modules/leakFile';
import * as tagActions from 'modules/tag';
import * as targetActions from 'modules/target';
import * as shareActions from 'modules/share';

// store 처리를 위한 컴포넌트
export const clearReduxStore = (dispatch, type) => {
  let targetModule = [];
  if (type === 'all') {
    targetModule = [
      currentStatusActions,
      loginActions,
      pwResetActions,
      registerActions,
      userActions,
      adminActions,
      templateActions,
      licenseActions,
      configActions,
      examActions,
      examSummaryActions,
      examListActions,
      leakFileActions,
      tagActions,
      targetActions,
      shareActions
    ];
  } else if (type === 'keep-login') {
    targetModule = [
      currentStatusActions,
      //loginActions,
      pwResetActions,
      registerActions,
      //userActions,
      adminActions,
      templateActions,
      licenseActions,
      configActions,
      examActions,
      examSummaryActions,
      examListActions,
      leakFileActions,
      tagActions,
      targetActions,
      shareActions
    ];
  } else if (type === 'logout') {
    targetModule = [
      currentStatusActions,
      //loginActions,
      pwResetActions,
      registerActions,
      userActions,
      adminActions,
      templateActions,
      licenseActions,
      configActions,
      examActions,
      examSummaryActions,
      examListActions,
      leakFileActions,
      tagActions,
      targetActions,
      shareActions
    ];
  } else if (type === '') {
    //
  } else if (type === '') {
    //
  } else if (type === '') {
    //
  } else if (type === '') {
    //
  } else if (type === '') {
    //
  } else if (type === '') {
    //
  } else if (type === '') {
    //
  } else if (type === '') {
    //
  } else if (type === '') {
    //
  } else if (type === '') {
    //
  }

  for (let i = 0, l = targetModule.length; i < l; i++) {
    const reducer = targetModule[i];
    dispatch(reducer.initialStore());
  }
};



// WEBPACK FOOTER //
// ./src/script/containers/InitialStore.js